module.exports = __webpack_public_path__ + "img/Millionaire-1.63036c8c.png";